export default __webpack_public_path__ + "static/media/paytm.4602a764.webp";